import { defineMessages } from 'react-intl';

export const messages = defineMessages({
	rollupStatusSectionTitle: {
		id: 'fastshift.dashboard.rollup-status-section.title',
		defaultMessage: 'Overall migration status',
		description: 'Title for the rollup status section',
	},
	rollupStatusSectionDescription: {
		id: 'fastshift.dashboard.rollup-status-section.description',
		defaultMessage:
			'Overall status is based on migration ticket statuses across all Cloud organizations. Check the migration tickets for details.',
		description: 'Description for the rollup status section',
	},
});
